'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RenderSpot = require('./RenderSpot');

var _RenderSpot2 = _interopRequireDefault(_RenderSpot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RenderSpot2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/RenderSpot/index.js
// module id = 177
// module chunks = 0